import moment from 'moment';

const titleCase = (str) => {
  return str.toLowerCase().split(' ').map(function(word) {
    return word.replace(word[0], word[0].toUpperCase());
  }).join(' ');
}

export const camelCase = (str) => {
  return str.toLowerCase().split(' ').map(word => {
    return word.replace(word[0], word[0].toUpperCase());
  }).join('');
}

export const prettyKey = (key) => {
  return titleCase(key.replace(/_/g, ' '));
}

export const formatDate = (date, format) => moment(date).format(format);
export const formatDateUtc = (date, format) => moment(date).utc().format(format);

export const formatMdn = (mdn) => {
  if (!mdn || mdn.length < 10) { return mdn; }
  return ['(', mdn.slice(0, 3), ') ', mdn.slice(3, 6), '-', mdn.slice(6)].join('');
}

export const pad = (n, size) => {
  let s = String(n);
  while (s.length < size) {
    s = '0' + s;
  }
  return s;
}

export const pluralize = (str, num) => {
  if (num !== 1) {
    str += 's';
  }
  return str;
}

export const percent = (num, denom) => {
  return Math.floor((num / denom) * 100);
}

export const toGB = (mb) => {
  let gb = (mb / 1024).toFixed(2);
  if (gb.slice(-3) === '.00') {
    return gb.slice(0, -3);
  }
  if (gb.slice(-1) === '0') {
    return gb.slice(0, -1);
  }
  return gb;
}

export const formatDataAmount = (data) => {
  if (typeof data === 'string') {
    data = parseFloat(data);
  }
  if (data >= 1024) {
    return [toGB(data), 'GB'];
  }
  return [data.toFixed(0), 'MB'];
}

export const addZeroIfNeeded = num => num < 10 ? '0' + num : num;

export const getDayAndMonth = date => {
  return `${addZeroIfNeeded(date.getMonth() + 1)}/${addZeroIfNeeded(date.getDate())}`
}

export const getDate = date => {
  return `${date.getFullYear()}-${addZeroIfNeeded(date.getMonth() + 1)}-${addZeroIfNeeded(date.getDate())}`
}

export const formatError = (() => {
  const excludedKeys = ['All', 'Detail'];
  const commonErrorText = 'Something went wrong 😞. Try again later.';

  const prettifyErrorKey = text => {
    return text.split('_').map(key => key.charAt(0).toUpperCase() + key.slice(1)).join(' ');
  }

  const createFinalErrorText = (errorObj, key) => {
    const prettyfiedKey = prettifyErrorKey(key);
    const errorMessage = createErrorMessage(errorObj, key)

    return excludedKeys.includes(prettyfiedKey) ? errorMessage : `${prettyfiedKey}: ${errorMessage}`;
  }

  const createErrorMessage = (errorObj, key) => {
    return Array.isArray(errorObj[key]) ? reduceErrorsArray(errorObj, key) : `${errorObj[key]}`;
  }

  const reduceErrorsArray = (errorObj, key) => {
    return errorObj[key].reduce((acc, errorMessage) => `${acc}\n${errorMessage}`, '');
  }

  const parseComplexError = error => {
    const keys = Object.keys(error);

    if (keys.length) {
      return keys.reduce((acc, key) => {
        if (Array.isArray(error[key]) || typeof error[key] === 'string') {
          return acc.concat('\n', createFinalErrorText(error, key));
        }

        if (typeof error[key] === 'object') {
          return parseComplexError(error[key]);
        }

        if (typeof error[key] === 'boolean') {
          return '';
        }
      }, '');
    } else {
      return '';
    }
  }

  return error => {
    if (error === null || error === void 0) {
      return commonErrorText;
    }

    const complexError = parseComplexError(error);
    if (complexError) {
      return complexError;
    }

    return commonErrorText;
  }
})();
